import config from '../services/config'

export function getEnvironment() {
  if (config.apiUrl.includes('dev')) {
    return 'dev'
  } else if (config.apiUrl.includes('sbx')) {
    return 'sbx'
  }

  return 'prod'
}
